function addOptionsByHours(datedd, today_d, time_d, options){
	if (datedd === today_d) {
      if (time_d > 12 && time_d < 19) {
        options += '<option value="ASAP">ASAP</option>';
      }
      if (time_d < 11) {
        options += '<option value="01:00PM-03:00PM">1:00PM to 3:00PM</option>';
      }
      if (time_d < 12) {
        options += '<option value="02:00PM-04:00PM">2:00PM to 4:00PM</option>';
      }
      if (time_d < 13) {
        options += '<option value="03:00PM-05:00PM">3:00PM to 5:00PM</option>';
      }
      if (time_d < 14) {
        options += '<option value="04:00PM-06:00PM">4:00PM to 6:00PM</option>';
      }
      if (time_d < 15) {
        options += '<option value="05:00PM-07:00PM">5:00PM to 7:00PM</option>';
      }
      if (time_d < 16) {
        options += '<option value="06:00PM-08:00PM">6:00PM to 8:00PM</option>';
      }
      
    } else {
		options += '<option value="01:00PM-03:00PM">1:00PM to 3:00PM</option>';
		options += '<option value="02:00PM-04:00PM">2:00PM to 4:00PM</option>';
		options += '<option value="03:00PM-05:00PM">3:00PM to 5:00PM</option>';
		options += '<option value="04:00PM-06:00PM">4:00PM to 6:00PM</option>';
		options += '<option value="05:00PM-07:00PM">5:00PM to 7:00PM</option>';
		options += '<option value="06:00PM-08:00PM">6:00PM to 8:00PM</option>';
    }
  return options;
}

function addProduct(quantity,variant_id) {
    var params = {
        type: "POST",
        url: '/cart/add.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function() {
            console.log("success!");
            location.reload();
        },
        error: function() {
            console.log("fail");
        }
    };
    $.ajax(params);
}
